import ProviderSegmentationInfo from './components/ProviderSegmentationInfo';
import './assets/ProviderSegmentationInfo.css';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import values from 'lodash/values';

// Actions
import {
  loadRetailers,
  createSegmentation
} from '../../shared/redux/entities/actions';

function mapStateToProps(state,props){
  return {
    retailers: values(state.entities.companies)
               .filter(c => !c.isBrand)
               .map(c => ({name: c.name, id: c.id})) || [],
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadRetailers,
    createSegmentation,
  },dispatch)
}

const ConnectedProviderSegmentationInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSegmentationInfo);


export default ConnectedProviderSegmentationInfo;



// WEBPACK FOOTER //
// ./src/routes/ProviderSegmentationInfo/index.js